import React, { useState, useEffect, useRef } from "react";
import "./AreaSociPage.scss";
import Hero from "../../common/Hero/Hero";
import { useTranslation, Trans } from "react-i18next";
import { Link, Redirect } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import FiltersBox from "../../common/FiltersBox/FiltersBox";
import Configuration from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import { getLinks } from "../../../reducers/soci";
import AemService from "../../../helpers/aemService";
import { getCorrectLink } from "../../../helpers/helpers";
import { getLanguagePaths } from "../../../helpers/menuConfig";
import i18n from "i18next";

const categories = [
  "assemblea-dei-soci",
  "comitato-di-indirizzo-strategico",
  "struttura-di-controllo",
  "garanzie-assicurative",
  "bilanci",
];

const SCROLL_ANIMATION_DURATION_MS = 200;

const AreaSociLatestDocuments = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="editorial-content-list editorial-content-list--with-icon" role="list">
      <div className="container">
        <div className="editorial-content-list--title-container">
          <div className="editorial-content-list--title headline-bold-fs2">
            {t("soci.content.header")}
          </div>
        </div>
        <div className="editorial-content-list-text-container">
          {categories.map((key) => {
            if (!data[key]) {
              return null;
            }
            const items = data[key].slice(0, 3);
            return (
              <div key={key}>
                <div className="editorial-content-list--section">
                  <p className="editorial-content-list-section--title headline-bold-fs5">
                    {t("areasoci.categories." + key)}
                  </p>
                  <ArrowLink className="gcap-cta" to={"/area-soci/" + key}>
                    {t("common.view.all")}
                  </ArrowLink>
                </div>
                <div>
                  <AreaSociDocumentList data={items} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
const AreaSociArchiveDocumentsList = (props) => {
  const { data } = props;
  const environmentUrl = `${Configuration.get("REACT_APP_GCAP_PUBLIC_HOST")}/`;

  return (
    <>
      {data &&
        data.length > 0 &&
        data.map((item, index) => (
          <div key={index} className="editorial-content-list-card" role="listitem">
            <div className="editorial-content-list--image-wrapper">
              <div className="editorial-content-list--image-container">
                <i
                  className="gc-icon-functional-doc-pdf-1-col"
                  aria-hidden="true"
                ></i>
              </div>
            </div>
            <div className="editorial-content-list-text-container">
              <div className="editorial-content-list--section">
                <div className="editorial-content-list-section--title headline-bold-uppercase-fs6">
                  {item.title}
                </div>
              </div>
            </div>
            <div className="editorial-content-list--footer">
              <div className="editorial-content-list--footer-actions">
                <a href={environmentUrl + item.link} className="btn btn-icon btn-icon-air" aria-label="Scarica la risorsa" download>
                  <i className="gc-icon-functional-download-1-col" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

const AreaSociDocumentList = (props) => {
  const { data } = props;
  const environmentUrl = `${Configuration.get("REACT_APP_GCAP_PUBLIC_HOST")}/`;

  return (
    <>
      {data &&
        data.length > 0 &&
        data.map((item, index) => (
          <div key={index} className="editorial-content-list-card" role="listitem">
            <div className="editorial-content-list--image-wrapper">
              <div className="editorial-content-list--image-container">
                <i
                  className="gc-icon-functional-doc-pdf-1-col"
                  aria-hidden="true"
                ></i>
              </div>
            </div>
            <div className="editorial-content-list-text-container">
              <div className="editorial-content-list--section">
                <div className="editorial-content-list-section--title headline-bold-uppercase-fs6">
                  {item.title}
                </div>
              </div>
            </div>
            <div className="editorial-content-list--footer">
              <div className="editorial-content-list--footer-actions">
                  <a href={environmentUrl + item.link} className="btn btn-icon btn-icon-air" aria-label="Scarica la risorsa" download>
                    <i className="gc-icon-functional-download-1-col" aria-hidden="true"></i>
                  </a>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};
const AreaSociUsefulLinks = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="editorial-content-list editorial-content-list--with-icon">
    <div className="container">
      <div className="editorial-content-list--title-container">
        <div className="editorial-content-list--title headline-bold-fs2">
          {t("soci.content.useful_links")}
        </div>
        </div>
          <AreaSociDocumentList data={data} />

      </div>
    </div>
  );
};
const AreaSociArchiveDocuments = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="editorial-content-list editorial-content-list--with-icon">
    <div className="container">
      <div className="editorial-content-list--title-container">
        <div className="editorial-content-list--title headline-bold-fs2">
          {t("soci.content.archive_documents")}
        </div>
        </div>
        <div>
          <AreaSociArchiveDocumentsList data={data} />
        </div>

    </div>
    </div>
  );
};

export const AreaSociMain = () => {
  const { t } = useTranslation();
  const lang = i18n.language;
  const links = useSelector((state) => state.soci[lang]);
  return (
    <div className="AreaSociMain" data-testid="AreaSociMain">
      <Hero
        backTo={"/dashboard"}
        backToText={t("common.back.home")}
        title={t("soci.header")}
        description={
          <div>
            <p>{t("soci.title")}</p>
            <Link className="link" to={"/area-soci/garanzie-assicurative"}>
              {t("soci.guarantees")}
            </Link>
          </div>
        }
      />

      <AreaSociUsefulLinks data={links.usefulLinks} />
      <AreaSociLatestDocuments data={links} />
      <AreaSociArchiveDocuments data={links.archive} />
    </div>
  );
};

const AreaSociTabs = ({ activeTab }) => {
  const { t } = useTranslation();
  const scrollRef = useRef(null);
  const leftBtnRef = useRef(null);
  const rightBtnRef = useRef(null);

  const determineOverflow = (scrollable) => {
  if (!scrollable) return "none";

  const contentWidth = scrollable.scrollWidth;
  const containerWidth = scrollable.clientWidth;
  const scrollLeft = scrollable.scrollLeft;
  const tol = 1;
  const isScrollable = contentWidth > containerWidth + tol;

  if (!isScrollable) {
    return "none";
  }

  const maxScrollLeft = contentWidth - containerWidth;
  const leftOverflow = scrollLeft > tol;
  const rightOverflow = scrollLeft < maxScrollLeft - tol;

  if (leftOverflow && rightOverflow) return "both";
  if (leftOverflow) return "left";
  if (rightOverflow) return "right";

    return "none";
  };

  const scrollElementTo = (element, to, duration = SCROLL_ANIMATION_DURATION_MS) => {
    const start = element.scrollLeft;
    const change = to - start;
    const startTime = performance.now();

    function animateScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      element.scrollLeft = start + change * progress;
      if (progress < 1) requestAnimationFrame(animateScroll);
      else updateNavigationState(element);
    }

    requestAnimationFrame(animateScroll);
  };

  const SnapTabs = (gcapTabs$, direction) => {
    if (!gcapTabs$) return;

    const tabs$ = gcapTabs$.querySelectorAll(".gcap-tab-list__item");
    const currentScroll = gcapTabs$.scrollLeft;
    let newScrollX = currentScroll;

    if (direction === "next") {
      for (let i = 0; i < tabs$.length; i++) {
        const tab$ = tabs$[i];
        const tabEndX = tab$.offsetLeft + tab$.clientWidth - currentScroll;
        if (tabEndX > gcapTabs$.clientWidth) {
          newScrollX = tab$.offsetLeft;
          break;
        }
      }
    }

    if (direction === "prev") {
      for (let i = tabs$.length - 1; i >= 0; i--) {
        const tab$ = tabs$[i];
        const tabStartX = tab$.offsetLeft - currentScroll;
        if (tabStartX < 0) {
          newScrollX = tab$.offsetLeft;
          break;
        }
      }
    }

    scrollElementTo(gcapTabs$, newScrollX, SCROLL_ANIMATION_DURATION_MS);
  };

  const updateNavigationState = (scrollable) => {
    const leftBtn = leftBtnRef.current;
    const rightBtn = rightBtnRef.current;
    const wrapper = scrollable.parentElement;

    if (!leftBtn || !rightBtn) return;

    const overflowing = determineOverflow(scrollable);

    leftBtn.classList.remove("disabled", "d-none");
    rightBtn.classList.remove("disabled", "d-none");
    wrapper.classList.remove("show-left-fade", "show-right-fade", "gcap-tabs__wrapper-no-scroll");

    if (overflowing === "right") {
      leftBtn.classList.add("disabled");
      wrapper.classList.add("show-right-fade");

    } else if (overflowing === "left") {
      rightBtn.classList.add("disabled");
      wrapper.classList.add("show-left-fade");

    } else if (overflowing === "both") {
      wrapper.classList.add("show-left-fade", "show-right-fade");

    } else if (overflowing === "none") {
      wrapper.classList.add("gcap-tabs__wrapper-no-scroll");
      leftBtn.classList.add("d-none");
      rightBtn.classList.add("d-none");

      leftBtn.setAttribute("aria-hidden", "true");
      rightBtn.setAttribute("aria-hidden", "true");
      leftBtn.setAttribute("tabindex", "-1");
      rightBtn.setAttribute("tabindex", "-1");
      return;
    }

    leftBtn.setAttribute("aria-hidden", "false");
    rightBtn.setAttribute("aria-hidden", "false");
    leftBtn.setAttribute("tabindex", "0");
    rightBtn.setAttribute("tabindex", "0");
  };

  useEffect(() => {
    const scrollable = scrollRef.current;
    const leftBtn = leftBtnRef.current;
    const rightBtn = rightBtnRef.current;
    if (!scrollable || !leftBtn || !rightBtn) return;

    const initialize = () => {
      if (scrollable) {
          updateNavigationState(scrollable);
      }
    };

    const timeoutId = setTimeout(initialize, 50);

    const handleClick = (e) => {
      const direction = e.currentTarget.dataset.direction;
      SnapTabs(scrollable, direction);
    };

    const handleScroll = () => updateNavigationState(scrollable);

    leftBtn.addEventListener("click", handleClick);
    rightBtn.addEventListener("click", handleClick);
    scrollable.addEventListener("scroll", handleScroll);

    requestAnimationFrame(() => updateNavigationState(scrollable));

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return (
  <section className="hero hero--level-3 hero--with-tabs hero-tabs">
    <div className="hero-container">
      <div className="hero__content d-flex flex-column justify-content-between">
        <div className="hero__content-with--tabs">

          <div className="gcap-tabs gcap-tabs--grey">
            <div className="container">
              <div className="gcap-tabs__wrapper">
                <nav
                  ref={scrollRef}
                  className="gcap-tabs-scrollable dragscroll"
                  data-scrollableid="scrollable-2"
                  data-overflowing="none"
                >
                  <ul className="nav gcap-tab-list" id="myTab3" role="tablist">
                    {categories.map((category) => (
                      <li
                        key={category}
                        className="gcap-tab-list__item nav-item"
                        role="presentation"
                      >
                        <Link
                          className={
                            "nav-link gcap-tab-hero paragraph-main-fs8" + (activeTab === category ? " active" : "")
                          }
                          to={"/area-soci/" + category}
                          role="tab"
                          aria-controls="example3Content1"
                          aria-selected="false"
                          data-toggle="tab"
                        >
                          {t("areasoci.categories." + category)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>
                <button ref={leftBtnRef} className="btn btn-icon btn-icon-air gcap-tabs__navigation gcap-tabs__navigation--left" data-direction="prev" type="button"></button>
                <button ref={rightBtnRef} className="btn btn-icon btn-icon-air gcap-tabs__navigation gcap-tabs__navigation--right" data-direction="next" type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

const AreaSociDetailPage = (props) => {
  const { t } = useTranslation();
  const { tab } = props;
  const lang = i18n.language;
  const capHoldingUrl = getCorrectLink(
    getLanguagePaths()["cap-holding-governance"][lang]
  );
  const links = useSelector((state) => state.soci[lang]);
  const originalData = links[tab] || [];
  const [filteredData, setFilteredData] = useState(links[tab] || []);

  useEffect(() => {
    setFilteredData(links[tab] || []);
  }, [tab, links]);

  const filterConfig = {
    fields: [
      {
        label: t("areasoci.filter.header"),
        name: "search_key",
        type: "input",
        placeholder: t("areasoci.filter.placeholder"),
        columnSize: 4,
      },
    ],
    validations: [],
    configuration: {
      hasReset: true,
    },
  };

  return (
    <div className="AreaSociDetailPage" data-testid="AreaSociDetailPage">
      <Hero
        backTo={"/area-soci"}
        backToText={t("soci.header")}
        title={t("areasoci.categories." + tab)}
        description={<></>}
      />

      <AreaSociTabs activeTab={tab} />

      {tab !== "garanzie-assicurative" && (
        <section style={{ marginTop: 60 }}>
          <FiltersBox
            config={filterConfig}
            onChange={() => null}
            data={originalData}
            onDataFiltered={setFilteredData}
            filter={(data, filters) => {
              if (Object.keys(filters).length === 0) {
                return data;
              }

              return data.filter((item) => {
                return (
                  String(item.title)
                    .toLowerCase()
                    .indexOf(filters.search_key) !== -1
                );
              });
            }}
          />
        </section>
      )}

      <div className="editorial-content-list editorial-content-list--with-icon">
        <div className="container">
            <div className={"gcap-rich-text"}>
              {tab === "garanzie-assicurative" ? (
                <>
                  <div>
                    <p>
                      {t("soci.content.tab.part1")}
                      <br />
                      <Trans
                        i18nKey="soci.content.tab.part1-2"
                        components={{
                          linkExternal: (
                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                            <a
                              className="soci-text-link"
                              href={capHoldingUrl}
                              rel="noopener noreferrer"
                              target="_blank"
                            />
                          ),
                        }}
                      />
                      <br />
                      {t("soci.content.tab.part2")}
                    </p>
                    <p>{t("soci.content.tab.part3")}</p>
                  </div>
                </>
              ) : (
                <AreaSociDocumentList data={filteredData} category={tab} />
              )}
            </div>
        </div>
      </div>
    </div>
  );
};

const AreaSociPage = (props) => {
  const match = props.match || props.computedMatch;
  const lang = i18n.language;
  const { params } = match;
  const { tab } = params;
  const aem = new AemService();
  const dispatch = useDispatch();

  useEffect(() => {
    aem.getSociLinks(lang).then((links) => {
      dispatch(getLinks(lang, links));
    });
    // eslint-disable-next-line
  }, [lang]);
  const isValidTab = (tab) => {
    return categories.includes(tab);
  };
  if (!tab) {
    return <AreaSociMain />;
  }
  if (!isValidTab(tab)) {
    return <Redirect to={"/area-soci"} />;
  }

  return <AreaSociDetailPage tab={tab} />;
};

AreaSociPage.propTypes = {};

export default AreaSociPage;
